import React from "react";

import * as styles from "../styles/MiniHeader.module.css";
import HeaderLogo from "./HeaderLogo";
import HeaderNav from "./HeaderNav";
import SideBar from "./SideBar";

const MiniHeader = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const hamClicked = React.useCallback(() => {
    setSidebarOpen(!sidebarOpen);
  }, [sidebarOpen]);

  return (
    <div className={styles.outer_container}>
      <div className={styles.container}>
        <HeaderLogo />
        <HeaderNav onHamburgerClicked={hamClicked} />
      </div>

      <SideBar
        open={sidebarOpen}
        close={() => {
          setSidebarOpen(false);
        }}
      />
    </div>
  );
};

export default MiniHeader;
